import { Inject, Injectable } from '@angular/core';
import {
  HttpClient,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { CONNECTOR_MANAGEMENT_API } from '../../app/variables';

@Injectable({
  providedIn: 'root',
})
export class EdrService {
  constructor(
    private readonly http: HttpClient,
    @Inject(CONNECTOR_MANAGEMENT_API) private readonly managementApiUrl: string,
  ) {}

  public requestDataAddress(
    id: string,
    observe?: 'body',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<any>;

  public requestDataAddress(
    id: string,
    observe?: 'response',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpResponse<any>>;

  public requestDataAddress(
    id: string,
    observe?: 'events',
    reportProgress?: boolean,
    options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext },
  ): Observable<HttpEvent<any>>;

  public requestDataAddress(
    id: string,
    observe: 'body' | 'response' | 'events' = 'body',
    reportProgress = false,
    options: { httpHeaderAccept?: 'application/json'; context?: HttpContext } = {},
  ): Observable<any> {
    if (!id) {
      throw new Error(
        'Required parameter id was null or undefined when calling requestDataAddress.',
      );
    }

    const base = this.managementApiUrl.replace(/\/$/, '');
    const url = `${base}/v3/edrs/${encodeURIComponent(id)}/dataaddress`;

    return this.http.get<any>(url, {
      observe,
      reportProgress,
      context: options.context,
      headers: options.httpHeaderAccept
        ? new HttpHeaders({ Accept: options.httpHeaderAccept })
        : undefined,
    } as any);
  }
}